import { baseurl } from '../../general';

async function fieldCheck(username, password, passwordRepeat) {
  let err;
  const passRep = passwordRepeat !== undefined;
  const userLength = username.length;
  if (!username) err = 'Fill username';
  else if (!password) err = 'Fill password';
  else if (passRep && !passwordRepeat) err = 'Fill repeat password';
  else if (passRep && password !== passwordRepeat) err = 'Password did not match';
  else if (userLength < 5) err = 'Username is too short';
  else if (userLength > 15) err = 'Username is too long';
  // else if (passLength < 5) err = 'Password is too short';
  // else if (passLength > 15) err = 'Password is too long';
  if (err) throw new Error(err);
}

async function api(url, username, password, correctStatus, fn) {
  const res = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ username, password }),
  });
  const json = await res.json();
  if (res.status === correctStatus) return json.token;
  throw new Error(fn(json));
}

const loginURL = `${baseurl}token-auth/`;
const signinURL = `${baseurl}users/`;

async function apiLogIn(...args) {
  return api(loginURL, ...args, 200, (json) => (json.non_field_errors[0]));
}

async function apiSignIn(...args) {
  return api(signinURL, ...args, 201, (json) => (json.username || json.password));
}

function handleSignIn(e, dispatch, fn, login, ...args) {
  const [username, password, passwordRepeat] = args;
  e.preventDefault();
  dispatch({ type: 'signin' });
  fieldCheck(username, password, passwordRepeat)
    .then(() => fn(username, password))
    .then((token) => { dispatch({ type: 'success' }); login(token); localStorage.setItem('token', token); })
    .catch((err) => dispatch({ type: 'error', value: err.toString().replace('Error: ', '') }));
}

const loginState = { username: '', password: '', error: '' };
const signinState = { ...loginState, passwordRepeat: '' };

function signInReducer(state, action) {
  switch (action.type) {
    case 'field':
      return { ...state, [action.field]: action.value };
    case 'signin':
      return { ...state, error: 'Signing In' };
    case 'success':
      return { ...state, ...signinState, error: 'Your logged in' };
    case 'error':
      return { ...state, error: action.value };
    default: break;
  }
  return state;
}

export {
  apiLogIn, apiSignIn, signInReducer, loginState, signinState, handleSignIn,
};
